function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M3023.7,4717.9l-522.9-290.1l-13.8-282.2c-37.5-785.4-169.7-2423.2-371-4625.4c-169.7-1858.8-292-3192.8-305.9-3376.3c-49.3-594,475.6-1079.4,964.9-893.9c142.1,53.3,288.1,181.5,347.3,307.9c57.2,122.3,110.5,382.8,136.2,657.1c27.6,294,27.6,1130.7,0,1608.2c-29.6,520.9-31.6,862.3-5.9,872.2c9.9,3.9,98.7-55.3,195.4-130.2c369-290.1,655.1-373,1112.9-319.7c534.8,63.2,941.3,246.7,1302.4,588.1c136.1,132.2,142.1,134.2,151.9,84.8c110.5-501.2,355.2-769.6,783.4-862.3c361.1-75,801.2,55.3,1071.5,319.7c331.5,325.6,418.3,893.9,211.1,1375.4l-49.3,112.5l-96.7-191.4c-128.3-254.6-339.4-517-461.8-576.2c-161.8-78.9-337.4-33.5-522.9,132.2l-98.7,88.8V1910v2592.9h-448h-446l11.8-497.3c7.9-274.3,19.7-1290.5,25.7-2257.4L6009.3-12l-153.9-112.5C5218-596.1,4501.7-886.2,4126.8-827c-274.3,45.4-430.2,193.4-522.9,505.2c-33.5,110.5-37.5,288.1-47.4,2725.1l-9.9,2606.7L3023.7,4717.9z"
}));

var SvgMean = function SvgMean(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-mean",
    viewBox: "0 0 1000 1000",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mean.aa65e172.svg";
export { ForwardRef as ReactComponent };